import Param from './SysConst2';
export const AppId: string = Param.AppId;
export const ApiServer: string = Param.ApiServer;
export const ApiVersion: string = Param.ApiVersion;
export const Authorization: string = Param.Authorization;
export const AdminServer: string = Param.AdminServer;
export const AutoOpenAdmin: Boolean = Param.AutoOpenAdmin;
export const AdminLoginUrl: string = Param.AdminLoginUrl;
